/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function() {
  
  $(document).on('click', '.box_product_infos h2', function(e) {
    const target = $(this).data('target')
    $('.box_product_infos .box_content').not($(target)).slideUp()
    $(target).slideToggle()
    $('.box_product_infos h2').not(this).find('.info_arrow').removeClass('open')
    $(this).find('.info_arrow').toggleClass('open');
  })

  if ($('#splide_main').length) {
    var main = new Splide('#splide_main', {
      type: 'fade',
      //heightRatio: 1.5,
      height: '800px',
      pagination: false,
      arrows: false,
      cover: true,
      breakpoints : {
        1300: {
          height: '700px',
        },
        640: {
          height: 'auto',
        },
      },
    });
    
    var thumbnails = new Splide('#splide_nav', {
      direction: 'ttb',
      type: 'loop',
      isNavigation: true,
      //focus: 'center',
      height: '800px',
      perPage: 3,
      perMove: 1,
      gap: '15px',
      pagination: false,
      cover : true,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
      breakpoints : {
        1300: {
          height: '700px',
        },
        640: {
          direction: 'ltr',
          perPage: 3,
          height: '180px',
        },
      },
    });
    
    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  }

  const gnt_to_animate = document.querySelectorAll('.slideshow_badge')
    if (gnt_to_animate.length) {
      const gnt_observer = new IntersectionObserver(function(entries) {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gnt_animate')
          } else {
            entry.target.classList.remove('gnt_animate')
          }
        }
      }, {
        rootMargin: '100px'
      })
      gnt_to_animate.forEach(function(element) {
        gnt_observer.observe(element)
      })
    }
  
})


